import momentTimezone from 'moment-timezone';

/**
 * FE calculated
 */
export const formatDateAsIsoSlovakTimezone = (date: string | Date) => {
  return momentTimezone(date).tz('Europe/Bratislava').toISOString(true);
};

export const formatDateToSlovakFormat = (date: Date | null) => {
  if (!date) return;

  const [month, day, year] = [
    date.getMonth(),
    date.getDate(),
    date.getFullYear()
  ];

  return `${day}.${month + 1}.${year}`;
};

export const convertDateToMarketDay = (date: string | Date): string => {
  const marketDayFullTimestamp = formatDateAsIsoSlovakTimezone(date);
  return marketDayFullTimestamp.substring(0, 10); // 'YYYY-MM-DD'
};

export const getCurrentMarketDay = (): string => {
  return convertDateToMarketDay(new Date());
};

export const getFirstJanuaryAsMarketDay = (): string => {
  const firstJanuaryOfCurrentYear = new Date(new Date().getFullYear(), 0, 1);
  return convertDateToMarketDay(firstJanuaryOfCurrentYear);
};

export const validateMarketDayValueFormat = (marketDay: string) => {
  const marketDayFormat = /^\d{4}-\d{2}-\d{2}$/; // 'YYYY-MM-DD'
  return marketDayFormat.test(marketDay);
};
